// extracted by mini-css-extract-plugin
module.exports = {"grid":"performance_grid__nqj2t","title":"performance_title__wk9DQ","items":"performance_items__wPgwA","desc":"performance_desc__wp0nH"};